import { cn } from '../../lib/utils';
import './ui.css';

export function Textarea({ className, ...props }) {
  return <textarea className={cn('ui-textarea', className)} {...props} />;
}
